import { castDateTimeFilters, DateTimeFiltersRequest } from '../../utils/requestHelper';
import { done, failed, RemoteData } from '../../utils/remote-data';
import { get } from './base';
import { Surveys } from '../../interfaces/survey';

export const getSurveys = async (
  patientId: string,
  dateFilters: DateTimeFiltersRequest,
): Promise<RemoteData<Surveys>> => {
  try {
    const res = await get(`/survey-responses?patientId=${patientId}`, {
      params: {
        ...castDateTimeFilters(dateFilters),
      },
    });
    return done(res.data);
  } catch (err) {
    return failed(err);
  }
};

export const surveyPDF = async (
  patientId: string,
  surveyId: number
): Promise<RemoteData<Blob>> => {
  try {
    const res = await get(`surveys/pdf?patientId=${patientId}&resultId=${surveyId}`, {
      responseType: 'arraybuffer', // Specify response type as arraybuffer
    });

    const blob = new Blob([res.data], { type: 'application/pdf' });
    return done(blob);
  } catch (err) {
    return failed(err);
  }
}